// extracted by mini-css-extract-plugin
module.exports = {"article-actions":"blog-article_article-actions__1ffhm","article-actions-link":"blog-article_article-actions-link__1QBga"};